import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup, useClosePopupOnNavigation } from '@gem/popups';

import { EditWorkspaceForm } from './EditWorkspaceForm/EditWorkspaceForm';
import { useEditWorkspacePopupPresenter } from './EditWorkspacePopup.presenter';

export const EditWorkspacePopup: FC<ICommonPopupsProps> = observer((props) => {
  const { t } = useTranslation();
  const presenter = useEditWorkspacePopupPresenter(props);
  useClosePopupOnNavigation(props.popupInstance);

  return (
    <Popup
      title={t('common_edit')}
      isOpened
      isHidden={props.popupInstance.isHidden}
      handlePrevStep={presenter.hasBackButton ? presenter.onBack : null}
      onClose={presenter.onClose}
    >
      <EditWorkspaceForm submit={presenter.submit} />
    </Popup>
  );
});
